import { useBoolean } from '@dreryk/react-common';

import { MagistralDrugInitialEditTemplate, MagistralDrugTemplateUse } from '../MagistralDrugTemplates.types';
import { MagistralDrugTemplateInsert } from '../readOnly/MagistralDrugReadOnly.types';

import { MagistralDrugTemplatesModal } from './MagistralDrugTemplatesModal';

type MagistralDrugTemplateModalOpenerChildrenRenderProps = {
   openModal: VoidFunction;
};

type MagistralDrugTemplateModalOpenerProps = {
   readonly children: (renderProps: MagistralDrugTemplateModalOpenerChildrenRenderProps) => JSX.Element;
   readonly defaultTemplate: MagistralDrugInitialEditTemplate;
   readonly onInsert: MagistralDrugTemplateInsert;
   readonly onUse: MagistralDrugTemplateUse;
   readonly shouldConfirmUse: boolean;
};

export const MagistralDrugTemplateModalOpener = (props: MagistralDrugTemplateModalOpenerProps): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);
   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? (
            <MagistralDrugTemplatesModal
               onClose={closeModal}
               initialEditTemplate={props.defaultTemplate}
               onInsert={props.onInsert}
               onUse={props.onUse}
               shouldConfirmUse={props.shouldConfirmUse}
            />
         ) : null}
      </>
   );
};
